import intl from 'react-intl-universal';
import searchEmptyState from 'assets/images/search-empty-state.svg';
import RenderNoRecords from 'Atoms/NoRecords/NoRecords';

const RequestsSearchEmptyState = () => (
  <tr>
    <td colSpan={13}>
      <RenderNoRecords
        dataTestId='search-empty-state'
        imageSrc={searchEmptyState}
        caption={intl.getHTML('REQUESTS_LIST_PAGE.SEARCH_EMPTY_STATE')}
        className='h-empty-table-body'
        labelClassName='text-center'
      />
    </td>
  </tr>
);

export default RequestsSearchEmptyState;
